import { useQuery } from "@tanstack/react-query";
import { keycloakClientService } from "../../services/keycloak-client";

export function useKeycloakClient(clientId: string) {
  return useQuery({
    queryKey: ["keycloakClient", clientId],
    queryFn: () => keycloakClientService.getKeycloakClient(clientId),
    enabled: !!clientId,
  });
}
